module.exports = __webpack_public_path__ + "img/4105.833231dd.png";